import routes from 'const/routes'
import getMFEConfig from 'helpers/getMFEConfig'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { updateModalStatus } from 'redux/modals/actions'
import { RootState } from 'redux/store'
import { PdfStatement } from 'statements-mfe'

const PdfStatementPage = () => {
  const mfeConfig = getMFEConfig('mfe')
  const dispatch = useDispatch()

  const { selectedAccount: selectedAccountState } = useSelector(
    (state: RootState) => ({
      selectedAccount: state.modals.selectedAccount
    })
  )

  const selectedAccount =
    selectedAccountState || sessionStorage.getItem('selectedAccountId')

  const navigate = useNavigate()
  const statementsButtonId = `statements-button-${selectedAccount}`

  return (
    <PdfStatement
      config={mfeConfig}
      selectedAccountId={selectedAccount}
      onReturnToStatementListClick={(e) => {
        e.preventDefault()
        navigate(routes.HOME)
        if (selectedAccountState) {
          dispatch(updateModalStatus('Statement', statementsButtonId))
        }
      }}
    />
  )
}

export default PdfStatementPage
